export default {"src":"/_next/static/media/checkIcon.c2aaa155.svg","height":27,"width":27};